import ajax from '@/utils/ajax';

export const head = '/web';
export const getHelpCategoryList = () => ajax(`${head}/v1/help-center/type/pageList?pageNum=1&pageSize=100&company=0&terminal=3`);
export const getHelpTitleList = (categoryId) => ajax(`${head}/v1/help-center/content/pageList?pageNum=1&pageSize=100&company=0&terminal=3&typeId=${categoryId}`);
export const getHelpContent = (titleId) => ajax(`${head}/v1/help-center/content/${titleId}`);
